// Toujours en relatif : les appels /api/* passent par le proxy Vite (dev)
// ou Traefik same-origin (prod). Aucun hostname Docker interne (backend:5000)
// ne doit apparaître dans le code exécuté par le navigateur.
// ⚠️ PORTE 3a (2026-08-03) — CETTE SURFACE A CHANGE D'AUTHENTIFICATION.
//
// `/api/v2/oracle/*` ne repose plus sur `X-Oracle-Token`, un jeton statique
// partage sans identite client. Elle exige desormais `X-API-Key`, avec quota,
// revocation et facturation par client.
//
// Ce tableau de bord n'est donc PLUS FONCTIONNEL en l'etat, et c'est
// deliberement laisse ainsi plutot que recable a moitie : une cle API dans un
// navigateur serait le meme defaut que le jeton partage. Deux issues tranchees
// par le commanditaire, l'une ou l'autre reste a implementer :
//
//   1. passer derriere la SESSION d'administration, sur l'hote distinct ;
//   2. appeler un RELAIS cote serveur qui porte la cle.
//
// En production il recevait deja 401 : `VITE_ORACLE_TOKEN` n'etait injecte que
// par l'overlay de developpement, desormais retire lui aussi.
const BASE_URL = "";
let oracleToken = null;

export function setOracleToken(token) {
    oracleToken = token;
}

export function isTokenSet() {
    return !!oracleToken;
}

async function apiV2Fetch(path, options = {}) {
    const headers = {
        "Content-Type": "application/json",
        ...(oracleToken ? { "X-Oracle-Token": oracleToken } : {}),
        ...options.headers,
    };

    try {
        const response = await fetch(`${BASE_URL}/api/v2/oracle${path}`, {
            ...options,
            headers,
        });

        if (response.status === 401) {
            throw new Error("UNAUTHORIZED");
        }

        if (response.status === 429) {
            throw new Error("RATE_LIMITED");
        }

        if (!response.ok) {
            throw new Error(`SERVER_ERROR_${response.status}`);
        }

        return await response.json();
    } catch (err) {
        if (err.message === "UNAUTHORIZED" ||
            err.message === "RATE_LIMITED" ||
            err.message.startsWith("SERVER_ERROR_")) {
            throw err;
        }
        throw new Error("OFFLINE");
    }
}

export function getSentinelStatus() {
    return apiV2Fetch("/sentinel/status");
}

export function getChainProof(limit = 200) {
    return apiV2Fetch(`/chain/proof?limit=${limit}`);
}
